import React from 'react'

const About = () => {
  return (
    <div name="about" className='w-full h-screen bg-gradient-to-b from-gray-800  to-black text-white'>
      <div className='max-w-screen-lg p-4 mx-auto flex-col justify-center
      w-full h-full'>
        <div className='pb-8'> 
            <p className=' text-4xl font-bold inline border-b-4 border-gray-500'>
                About </p>
        </div>

        <p className='text-xl mt-20'>
        Greetings! I'm Omkar Uttam Bate, currently pursuing my B Tech. 
        in <strong style={{color: "#5b99a6"}}>Information Technology</strong>  at  <br /> <strong style={{color: "#5b99a6"}}> G H Raisoni Institute of Engineering and Technology in Pune.</strong>  <br />
        My academic journey has been complemented by a passionate exploration of various technology domains, with a strong inclination towards Frontend Development. Through hands-on experiences and project endeavors, I've cultivated a proficiency in coding, design, and user experience, shaping my technical expertise. My commitment to continuous learning is rivaled only by my enthusiasm for connecting with new individuals and exploring diverse opportunities.
        </p>
        <br />

      

      </div>


    </div>
  )
}

export default About
